import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-jet-gray-50 pt-[70px]">      <main className="flex items-center justify-center min-h-[calc(100vh-140px)] py-12">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="mb-8">
            <div className="text-9xl font-bold text-jet-yellow mb-4">404</div>
            <h1 className="text-4xl font-bold text-jet-gray-900 mb-4">Page Not Found</h1>
            <p className="text-xl text-jet-gray-600 mb-8">
              Sorry, the page you are looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="mb-8">
            <div className="text-6xl mb-4">✈️</div>
            <p className="text-jet-gray-500 mb-6">
              It looks like you've taken a wrong turn. Let's get you back on track!
            </p>
          </div>

          <div className="space-y-4 mb-8">
            <button
              onClick={() => navigate('/')}
              className="bg-jet-yellow hover:bg-jet-yellow-hover text-jet-gray-900 font-semibold px-8 py-3 rounded-md transition-colors mr-4"
            >
              Go to Homepage
            </button>
            <button
              onClick={() => navigate(-1)}
              className="border border-jet-gray-300 hover:border-jet-gray-400 text-jet-gray-700 font-medium px-8 py-3 rounded-md transition-colors"
            >
              Go Back
            </button>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-semibold text-jet-gray-900 mb-4">Popular Pages</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <button
                onClick={() => navigate('/search-flight')}
                className="flex items-center p-3 text-left hover:bg-jet-gray-50 rounded-md transition-colors"
              >
                <div className="w-10 h-10 bg-jet-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-jet-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
                <div>
                  <div className="font-medium text-jet-gray-900">Search Flights</div>
                  <div className="text-sm text-jet-gray-500">Find and book flights</div>
                </div>
              </button>

              <button
                onClick={() => navigate('/flight-status')}
                className="flex items-center p-3 text-left hover:bg-jet-gray-50 rounded-md transition-colors"
              >
                <div className="w-10 h-10 bg-jet-green-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-jet-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                  </svg>
                </div>
                <div>
                  <div className="font-medium text-jet-gray-900">Flight Status</div>
                  <div className="text-sm text-jet-gray-500">Track your flight</div>
                </div>
              </button>

              <button
                onClick={() => navigate('/help')}
                className="flex items-center p-3 text-left hover:bg-jet-gray-50 rounded-md transition-colors"
              >
                <div className="w-10 h-10 bg-jet-yellow-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-jet-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <div>
                  <div className="font-medium text-jet-gray-900">Help Center</div>
                  <div className="text-sm text-jet-gray-500">Get support</div>
                </div>
              </button>

              <button
                onClick={() => navigate('/contact-us')}
                className="flex items-center p-3 text-left hover:bg-jet-gray-50 rounded-md transition-colors"
              >
                <div className="w-10 h-10 bg-jet-red-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-jet-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <div>
                  <div className="font-medium text-jet-gray-900">Contact Us</div>
                  <div className="text-sm text-jet-gray-500">Get in touch</div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>    </div>
  );
};

export default NotFoundPage;